var map = {
	"./Pam_01.jpg": 338847,
	"./Pam_02.jpg": 924496,
	"./Pam_03.jpg": 93069,
	"./Pam_04.jpg": 257638,
	"./Pam_05.jpg": 817123,
	"./Pam_06.jpg": 871060,
	"./Pam_07.jpg": 385393,
	"./Pam_08.jpg": 14282,
	"./Pam_09.jpg": 770119,
	"./Pam_10.jpg": 405721,
	"./Pam_11.jpg": 961372,
	"./Pam_12.jpg": 502891
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 377644;